import { FC } from "react";
import PageTemplate from "../../components/templates/PageTemplate";
import { Grid2 } from "@mui/material";
import RoomCard from "./RoomCard";
import { Link, useLoaderData } from "react-router-dom";
import { Room } from "../../app/types/RoomsTypes";
import Button from "../../components/atoms/Button";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import LoaderGlobal from "../../components/molecules/LoaderGlobal";
import { getFontClass } from "../../helpers/fontUtils";

interface Props {}

const RoomsModule: FC<Props> = () => {
  const rooms = useLoaderData() as Room[];
  const { generalSettings, requestsLoading, generalLoading, locale } =
    useSelector((state: RootState) => {
      return {
        generalLoading: state.generalSettings.loading,
        generalSettings: state.generalSettings.generalSettings,
        requestsLoading: state.requests.loading,
        locale: state.generalSettings.locale,
      };
    });

  if (
    requestsLoading ||
    generalLoading ||
    Object.keys(generalSettings).length === 0
  ) {
    return <LoaderGlobal />;
  }

  const requestOnlyRooms = rooms.filter((item) => item.request_only);

  return (
    <PageTemplate>
      {requestOnlyRooms.length > 0 && (
        <div className="flex flex-col items-center my-4 gap-2">
          <span
            // style={{ marginBottom: 10 }}
            className={`text-[32px] font-normal 2xl:w-[50vw] w-[80vw] ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {generalSettings.events_text.requestRoomHeader[locale]}
          </span>
          <span
            className={`text-[16px] flex 2xl:w-[50vw] w-[80vw] ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {generalSettings.events_text.requestRoomDesc[locale]}
          </span>
        </div>
      )}
      <div className="justify-center flex flex-col 2xl:w-[50vw] w-[80vw] xs:w-full xs:mx-8">
        <Grid2 container columnSpacing={4} className="w-full">
          {requestOnlyRooms.map((room) => {
            return (
              <Grid2
                key={`room_card_${room.id_room}`}
                className="mt-[14px]"
                size={{
                  md: 12 / generalSettings.events_styling.grid_columns_pc,
                  xs: 12 / generalSettings.events_styling.grid_columns_mobile,
                }}
              >
                <RoomCard
                  room={room}
                  link={`/${generalSettings.url}/em/r/${room.id_room}/details`}
                  buttonLink={`/${generalSettings.url}/em/r/${room.id_room}`}
                />
              </Grid2>
            );
          })}
        </Grid2>

        <div className="mt-4 flex flex-col gap-2">
          <span
            className={`text-[32px] ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {generalSettings.events_text.requestFormHeader[locale]}
          </span>
          <span
            className={`text-base ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {generalSettings.events_text.requestFormDesc[locale]}
          </span>
        </div>
        <Link
          className={`mt-8 w-[200px] ${getFontClass(generalSettings.events_styling.font_family)}`}
          to={`/${generalSettings.url}/em/r`}
        >
          <Button type="submit" className={`p-4 w-[200px] rounded mt-[10px] `}>
            {generalSettings.events_text.buttonText[locale]}
          </Button>
        </Link>
      </div>
    </PageTemplate>
  );
};

export default RoomsModule;
